// src/pages/NotFoundPage.js — 404 dans le lore Takkyu Oni
import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "./NotFoundPage.css";

const ONI_MESSAGES = [
  { emoji:"🌑", jp:"迷子の鬼", en:"Le démon est perdu.", sub:"Cette page n'existe pas dans les registres démoniaques." },
  { emoji:"🕷️", jp:"蜘蛛の罠", en:"Tu es tombé dans un piège.", sub:"Le Spider Oni a tissé sa toile ici. Il n'y a rien." },
  { emoji:"🦝", jp:"狸の罠",   en:"Le Tanuki t'a trompé.", sub:"Tu pensais qu'il y avait quelque chose ici. Il n'y a rien. C'est le but." },
  { emoji:"🐸", jp:"蛙の術",   en:"La balle a disparu.", sub:"Comme ton revers à 10-9. Introuvable." },
  { emoji:"🦭", jp:"失われた", en:"L'Oni applaudit ton erreur.", sub:"Personne ne sait pourquoi. Lui non plus." },
];

const SUGGESTIONS = [
  { to:"/",        label:"Accueil",        icon:"🏠" },
  { to:"/awaken",  label:"Réveiller mon démon", icon:"👹" },
  { to:"/lore",    label:"Le Lore",        icon:"📜" },
  { to:"/ranking", label:"Leaderboard",    icon:"⚡" },
  { to:"/merch",   label:"Boutique",       icon:"👕" },
];

export default function NotFoundPage() {
  const location  = useLocation();
  const [oni]     = useState(() => ONI_MESSAGES[Math.floor(Math.random() * ONI_MESSAGES.length)]);
  const [glitch,  setGlitch]  = useState(false);
  const [counter, setCounter] = useState(0);

  // Glitch effect loop
  useEffect(() => {
    const interval = setInterval(() => {
      setGlitch(true);
      setTimeout(() => setGlitch(false), 200);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  // Increment "errors" counter for the lore
  useEffect(() => {
    const n = parseInt(localStorage.getItem("takkyu_404_count") || "0") + 1;
    localStorage.setItem("takkyu_404_count", n);
    setCounter(n);
  }, []);

  return (
    <div className="nf-page">
      {/* Background big 404 */}
      <div className="nf-bg-number" aria-hidden>404</div>

      {/* Speed lines */}
      <div className="nf-speed-lines" aria-hidden/>

      <div className="nf-content">

        {/* Oni */}
        <div className={`nf-oni${glitch ? " glitch" : ""}`} aria-hidden>
          {oni.emoji}
        </div>

        {/* Error code */}
        <div className="nf-code">
          <span className="nf-code-label">ERREUR</span>
          <span className={`nf-code-num${glitch ? " glitch-text" : ""}`}>404</span>
        </div>

        {/* JP text */}
        <p className="nf-jp">{oni.jp}</p>

        {/* Main message */}
        <h1 className="nf-title">{oni.en}</h1>
        <p className="nf-sub">{oni.sub}</p>

        {/* Path that doesn't exist */}
        <div className="nf-path-badge">
          <span className="nf-path-label">PAGE INTROUVABLE</span>
          <code className="nf-path">{location.pathname}</code>
        </div>

        {/* Lore counter */}
        {counter > 1 && (
          <p className="nf-counter">
            {oni.emoji} Tu as déjà erré {counter} fois dans le néant. Ton démon note ça.
          </p>
        )}

        {/* Suggestions */}
        <div className="nf-suggestions">
          <p className="nf-suggestions-label">OÙ VEUX-TU ALLER ?</p>
          <div className="nf-links">
            {SUGGESTIONS.map(s => (
              <Link key={s.to} to={s.to} className="nf-link">
                <span>{s.icon}</span>
                <span>{s.label}</span>
              </Link>
            ))}
          </div>
        </div>

        {/* Back button */}
        <button className="btn btn-ghost nf-back" onClick={() => window.history.back()}>
          ← RETOUR EN ARRIÈRE
        </button>
      </div>
    </div>
  );
}
